import PropTypes from 'prop-types';
import {Route, Redirect} from 'react-router-dom';
import SubRoutes from './SubRoutes';

const EnhancedRoute = props => {

    const {
        layout: Layout,
        redirect,
        routeConfig
    } = props;

    if (redirect) {
        return <Redirect to={{pathname: redirect}} />;
    }

    const {subRoutes} = routeConfig;

    const WrapperComponent = props => (
        Layout
            ? (
                <Layout {...props} routeConfig={routeConfig}>
                    <SubRoutes {...props} routes={subRoutes} routeConfig={routeConfig} />
                </Layout>
            )
            : <SubRoutes {...props} routes={subRoutes} routeConfig={routeConfig} />
    );

    // eslint-disable-next-line react/jsx-no-bind
    return <Route render={WrapperComponent} />;
};

EnhancedRoute.propTypes = {
    redirect: PropTypes.string.isRequired,
    layout: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
    routeConfig: PropTypes.shape().isRequired,
};

export default EnhancedRoute;
